import React from 'react';

const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  fontWeight: 'bold',
  fontSize: '14'
};

const formatGroupLabel = (data) => (
  <div style={groupStyles}>
    <span>{data.label}</span>
  </div>
);

const indicatorSeparatorStyle = {
  width: 0
};

const IndicatorSeparator = ({ innerProps }) => {
  return <span style={indicatorSeparatorStyle} {...innerProps} />;
};

const DropdownIndicator = ({ props }) => {
  return <div className="triangle-down mr8" {...props} />;
};

export {
  formatGroupLabel,
  indicatorSeparatorStyle,
  IndicatorSeparator,
  DropdownIndicator
};
